import React, { Component } from 'react';
import Button from './Button';

class Search extends Component {
  render() {
    return (
      <section className="search">
        <form className="container" action="/search" method="GET">

          <label className="search__title">Поиск по личному кабинету</label>
          <input type="search" name="v" placeholder="Что желаете найти?"/>

          <Button theme="search">
            <i className="ico ico_search"></i>
            <span>Найти</span>
          </Button>
        </form>
      </section>
    );
  }
}
export default Search;